export enum EVisa2PayCardType {
  visa = 'VISA',
  mastercard = 'MASTERCARD',
}

export const VISA2PAY_CARD_TYPES = Object.values(EVisa2PayCardType);
